import * as parts from './parts'

const { loginPromptColors, extensionPromptColors } = parts
export interface LoginColors {
  LoginPrompt: typeof loginPromptColors
  ExtensionPrompt: typeof extensionPromptColors
}

export const loginColors: LoginColors = {
  LoginPrompt: loginPromptColors,
  ExtensionPrompt: extensionPromptColors,
}
